import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
// import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { LoadingProvider } from "@modules/shared/helpers/loading-provider.helper";
import LoadingOverlay from "components/shared/LoadingOverlay/LoadingOverlay";
import { AuthProvider } from "@modules/auth/contexts/auth-plus.context";

const rootElement = document.getElementById("root");

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement as HTMLElement);
  root.render(
    <React.StrictMode>
      <LoadingProvider>
        <BrowserRouter>
          <AuthProvider>
            <LoadingOverlay />
            <App />
          </AuthProvider>
        </BrowserRouter>
      </LoadingProvider>{" "}
    </React.StrictMode>,
  );
}

// reportWebVitals();
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js")
    .then((registration) => {
      // console.log("✅ Service Worker registered with scope:", registration.scope);
    })
    .catch((err) => {
      // console.error("❌ Service Worker registration failed:", err);
    });
}
